// show link to high school students after october 1st of their senior year and before end of school year, july 1st
export const showFinancialAidAwardLetters = (student) => {
  const TODAY = new Date();
  const JULY_FIRST = new Date(TODAY.getFullYear(), 6, 1);
  const OCTOBER_FIRST = new Date(TODAY.getFullYear(), 9, 1);

  const isSenior = student.highSchoolInfo && student.highSchoolInfo.senior;
  const validShowDatesForLetters = TODAY < JULY_FIRST || TODAY > OCTOBER_FIRST;

  return isSenior && validShowDatesForLetters;
};
